import styled from 'styled-components/macro';
import modularScale from '../../../styles/helpers/modular-scale';

const LoadingErrorWrapper = styled('div')<any>`
  display: flex;
  flex-direction: column;
  margin: ${({ theme }): string => theme.spacing.medium} 0;
  color: ${({ theme }): string => theme.CasperGrey};

  details {
    max-width: 20em;
    margin-top: ${modularScale(-1)};
    font-size: ${modularScale(-1)};

    @media screen and (min-width: 40rem) {
      margin-top: 0;
    }
  }

  a {
    &:focus,
    &:active {
      color: ${({ theme }): string => theme.AccentGreen};
    }
  }

  pre {
    font-size: ${modularScale(-1)};
  }

  svg {
    width: ${({ type }): string => modularScale(type === 'bundle' ? 5 : 3)};
    height: ${({ type }): string => modularScale(type === 'bundle' ? 5 : 3)};
  }

  @media screen and (min-width: 40rem) {
    p,
    details {
      font-size: ${modularScale(0)};
    }
  }
`;

/**
 * @component
 */
export default LoadingErrorWrapper;
